import { render } from "./activityInfo.vue?vue&type=template&id=2456c6d8&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"

import "./activityInfo.vue?vue&type=style&index=0&id=2456c6d8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2456c6d8"]])

export default __exports__